import React from 'react'
import IndividualTraineeTable from '../../components/IndividualTrainee/IndividualTraineeTable'

export const IndividualTraineePage = () => {
  return (
    <IndividualTraineeTable/>
  )
}
